import { useSyncExternalStore } from "react"

const subscribe = () => () => undefined
const getBrowserSnapshot = () => typeof IntersectionObserver !== "undefined"
const getServerSnapshot = () => true

/** Keeps SSR and hydration stable while exposing the browser capability. */
export function useSupportsIntersectionObserver(): boolean {
  return useSyncExternalStore(subscribe, getBrowserSnapshot, getServerSnapshot)
}
